import { render, staticRenderFns } from "./RecapComponent.vue?vue&type=template&id=2f31122e&scoped=true"
import script from "./RecapComponent.vue?vue&type=script&lang=js"
export * from "./RecapComponent.vue?vue&type=script&lang=js"
import style0 from "./RecapComponent.vue?vue&type=style&index=0&id=2f31122e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31122e",
  null
  
)

export default component.exports